module.exports = __webpack_public_path__ + "img/empty.549bc60d.png";